import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.8337 6.46309V6.99976C12.8329 8.25767 12.4256 9.48165 11.6724 10.4892C10.9193 11.4967 9.86057 12.2337 8.65428 12.5904C7.44799 12.947 6.15873 12.9042 4.97877 12.4683C3.79881 12.0323 2.79137 11.2267 2.10672 10.1714C1.42206 9.11611 1.09687 7.8678 1.17964 6.61261C1.2624 5.35742 1.7487 4.16262 2.56599 3.20638C3.38328 2.25015 4.48778 1.58373 5.71477 1.30651C6.94175 1.02929 8.22548 1.15612 9.3745 1.66809",
		stroke: "#004A96",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.8333 2.3335L7 8.17266L5.25 6.42266",
		stroke: "#004A96",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckCircle;
